<template>
  <div class="wrapper" v-loading="showLoading">
    <common-header url="channelQuery" />

    <channel-details
      :details="details"
      :company-list="companys"
      :readonly="true"
      :paylist="payList"
      :withholdlist="withholdList"
      :bankRepayRecordRespList="bankRepayRecordRespList"
      disabled
    />
  </div>
</template>

<script>
import ChannelDetails from './components/ChannelDetails'
import mixin from '@/mixins/dataListHeight.js'
import queryPage from '@/mixins/queryPage'
import { mapGetters } from 'vuex'
export default {
  mixins: [mixin, queryPage],
  components: {
    ChannelDetails
  },

  props: ['id'],

  data() {
    return {
      showLoading: false,
      // companys: [],
      provinceList: [],
      postData: {
        // 渠道基础信息
        id: '', //渠道号
        bankName: '', //渠道全称
        forShort: '', //渠道简称
        areaCode: '', //区号
        contractNo: '', //合同编号
        tpdu: '', //TPDU
        msgHead: '', //报文头
        cutTime: '', //日切时间
        loanPeriod: '', //贷款期限
        isConvert: '', //卡号转换 0: 否 1: 是
        liquidationReturn: '', //清算返回
        msgType: '', //通讯方式 1: VPN 2：普通
        clearNum: '', //重复次数
        alreadyQuota: '', //已批复额度
        usedQuota: '', //已使用额度
        productId: '', //产品ID
        bankExit: '', //渠道接口 1：提供; 2：不提供
        createTime: '', //建档时间
        workArea: '', //作业区域
        companyName: '', //收单机构

        // 渠道成本
        settlementMethod: '', //资金成本 ("结算方式 1:年化利率 2:交易额")\
        annualizedInterestRate: '', //年化利率 - 资金成本为1时传入
        interestCost: '', //汇率成本(银行利润占总利润的百分比)  存小数 - 资金成本为2时传入

        repayCostNo: '', //代付成本("代付成本选择 1:渠道自用通道 2:渠道自用第三方通道 3:盈众第三方通道")
        repayCostNoType: '', //通道类型（代付成本选择为 1 时） 1：银行 2：第三方支付公司"
        repayCostThisBank: '', //本行代付 元（通道类型为 1 时）
        repayCostOtherBank: '', //跨行代付 元（通道类型为 1 时）
        repayCostThirdPartyBank: '', //付款成本（通道类型为 2 时）
        repayCostId: '', //关联通道ID 代付成本选择为 2 （渠道自用第三方通道）或者为 3 （盈众第三方通道） 时

        deductCostNo: '', //代扣成本选择 1:渠道自用通道 2:渠道自用第三方通道 3:盈众第三方通道
        bankRepayRecordList: [], //代扣成本--渠道自用通道,代扣能力
        deductCostId: '', //关联通道ID 代扣成本选择为 2 （渠道自用第三方通道）或者为 3 （盈众第三方通道） 时

        // 结算信息
        busUserName: '', //财务对接人姓名
        busUserPhone: '', //财务对接人电话号^((13[0-9])|(14[5,7,9])|(15[^4])|(18[0-9])|(17[0,1,3,5,6,7,8]))\\d{8}$
        techUserName: '', //技术对接人姓名
        techUserPhone: '', //技术对接人电话号
        settleName: '', //结算账户名称
        settleCardNo: '', //结算账号
        settleOpenBank: '', //开户行名称
        bankLogo: '', //标识上传(图片)
        remark: '', //备注

        // 合同模版
        contractJson: [] //合同模板 JSON
      },
      details: {},
      bankRepayRecordRespList: [
        {
          cardId: '',
          bankName: '',
          sign: '',
          repayRate: '',
          repayLowest: ''
        }
      ],
      payList: [{ value: '', label: '' }],
      withholdList: [{ value: '', label: '' }]
    }
  },

  async created() {
    // 获取渠道详情
    await this.getCompanyDetails()

    this.getCompanyList()
    // this.getWorkArea()

    this.getWorkMenu()
  },

  computed: {
    ...mapGetters(['selects'])
  },

  methods: {
    // 获取详情
    async getCompanyDetails() {
      const {
        id,
        $store: { dispatch }
      } = this
      const dispatchEvent = 'T4/channelQuery/getCompanyDetails'
      this.showLoading = true
      let data = await dispatch(dispatchEvent, { id })

      if (data) {
        console.log(data, 'data')
        // 判断渠道成本显示
        // 1.代付成本
        if (data.repayPayChannel) {
          let temp = []

          data.repayPayChannel.map(item => {
            temp.push({ value: item.id, label: item.passagewayName })
          })

          temp ? (this.payList = temp) : ''
        }

        // 2.代扣成本
        if (data.deductPayChannel) {
          let temp = []
          data.deductPayChannel.map(item => {
            temp.push({ value: item.id, label: item.passagewayName })
          })

          temp ? (this.withholdList = temp) : ''
        }

        // 3.代扣能力
        data.deductPayChannel
          ? (this.bankRepayRecordRespList = data.deductPayChannel)
          : ''
        this.details = data.bank

        // 作业区域
        if (data.city) {
          this.details.city = data.city
        }

        this.showLoading = false
        let ids = []
        if (data.cities) {
          data.cities.map(item => {
            ids.push(item.citiesId)
          })
        }
        this.details.workArea = ids
      }
    },

    // 获取关联通道  replaceType:代付1，代扣2 , channelType:渠道自用第三方1，盈众2
    async getChannel(replaceType, channelType) {
      let { dispatch } = this.$store
      let dispatchEvent = 'T4/channelQuery/checkChannelBind'
      let res = await dispatch(dispatchEvent, { replaceType, channelType })
      let passagewayNameList = []
      res.map(item => {
        passagewayNameList.push({
          value: item.id,
          label: item.passagewayName
        })
      })

      return passagewayNameList

      // replaceType == 1
      //   ? (this.payList = passagewayNameList)
      //   : (this.withholdList = passagewayNameList)
      // // this.passagewayNameList = passagewayNameList

      // // console.log('关联通道', res)
    },

    // 获取作用区域
    getWorkArea() {
      const { dispatch } = this.$store
      const dispatchEvent = 'T4/channelQuery/getWorkArea'

      dispatch(dispatchEvent).then(res => {
        let list = []
        res.map(item => {
          list.push({
            value: item.citiesId,
            label: `${item.provinceName}${item.citiesName}`
          })
        })
        // this.cityList = list
      })
    },

    async getWorkMenu() {
      let { dispatch } = this.$store
      let dispatchEvent = 'T4/channelQuery/getWorkMenu'
      let res = await dispatch(dispatchEvent)
      let list = []
      res.map(item => {
        let arr = []
        item.cityList.map(v => {
          arr.push({
            value: v.id,
            label: v.name,
            parentId: v.parentId
          })
        })
        list.push({
          value: item.id,
          label: item.name,
          children: arr
        })
      })
      this.provinceList = list
      // dispatch(dispatchEvent).then(res => {
      //   let list = []
      //   res.map(item => {
      //     list.push({
      //       value: item.id,
      //       lable: item.name
      //     })
      //   })
      //   this.provinceList = list
      //   console.log(JSON.parse(JSON.stringify(this.provinceList)), '作业区域')
      // })
    }
  }
}
</script>
